import {Component, DoCheck, Input, OnInit} from '@angular/core';
import {ExgModalService} from 'exc-controls-v2';
import {ApplicationService} from '../../services/application.service';
import {ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';

@Component({
  selector: 'app-modal-oe-calculation',
  templateUrl: './modal-oe-calculation.component.html',
})
export class ModalOeCalculationComponent extends ExcTranslation implements OnInit, DoCheck {
  @Input() data: any;

  dataModel: any = {
    ctName: '',
    ctDescription: '',
    ct_aue_enmIdent_Versicherungsart: -1,
    ct_enmIdent_DokTyp: null,
    ctIsDraft: true
  };
  dataModelClone: any;
  isNew = true;
  isDisabled = false;
  dokTypList = [] as any[];

  constructor(
    private modalSvc: ExgModalService,
    private appSvc: ApplicationService,
    public enumSvc: EnumerationService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.dokTypList = this.getDokTypList();

    if (!this.data) {
      this.dataModelClone = this.appSvc.helperObj.clone(this.dataModel);
      this.isNew = true;
    } else {
      this.dataModelClone = this.appSvc.helperObj.clone(this.data);
      this.dataModel = this.appSvc.helperObj.clone(this.data);
      this.isNew = false;
    }
  }

  ngDoCheck(): void {
    if (this.appSvc.helperObj.changed(this.dataModel, this.dataModelClone)) {
      if (this.dataModelClone.ctName && this.dataModelClone.ctName.length > 0
        && this.dataModelClone.ct_enmIdent_DokTyp) {
        this.isDisabled = false;
      }
    } else {
      this.isDisabled = true;
    }
  }

  getDokTypList(): any[] {
    const list = this.enumSvc.getEnumerationList('DokTyp');

    return list.filter((e, i) => list.findIndex(x => x.enmIdent === e.enmIdent) === i);
  }

  delete(): void {
    this.modalSvc.action({
      ctName: this.dataModelClone?.ctName,
      ctDescription: this.dataModelClone?.ctDescription,
      ct_aue_enmIdent_Versicherungsart: this.dataModelClone?.ct_aue_enmIdent_Versicherungsart,
      ctUPT: this.dataModelClone?.ctUPT,
      ctID: this.dataModelClone?.ctID,
      del: true
    });
  }

  cancel(): void {
    this.close();
  }

  close(): void {
    this.modalSvc.close();
  }

  save(): void {
    if (this.appSvc.helperObj.changed(this.dataModel, this.dataModelClone)) {
      if (this.dataModelClone.ctName && this.dataModelClone.ctName.length > 0
        && this.dataModelClone.ct_enmIdent_DokTyp) {
        this.modalSvc.action(this.dataModelClone);
      }
    }
  }
}
